import { render } from "./D1D9.vue?vue&type=template&id=07ac53a0&scoped=true"
import script from "./D1D9.vue?vue&type=script&lang=js"
export * from "./D1D9.vue?vue&type=script&lang=js"

import "./D1D9.vue?vue&type=style&index=0&id=07ac53a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ac53a0"]])

export default __exports__